export enum LpcoFields {
  REGISTERED_IMPORTER_NUMBER = 'registeredImporterNumber',
  VEHICLE_ELIGIBILITY_NUMBER = 'vehicleEligibilityNumber',
  PERMISSION_LETTER = 'permissionLetter',
  TTB_IMPORTER_PERMIT_NUMBER = 'ttbImporterPermitNumber',
  IRC_REGISTRY_NUMBER = 'ircRegistryNumber',
}
